const BUTTON_SELECTOR = '[data-collection-load-more]';

function getGridFromButton(button) {
  const section = button.closest('.shopify-section');
  if (!section) return null;

  return section.querySelector('[ref="grid"]');
}

function getHiddenItems(grid) {
  if (!(grid instanceof HTMLElement)) return [];

  return Array.from(grid.children).filter(
    (item) => item instanceof HTMLElement && item.hidden
  );
}

function revealItems(grid, count) {
  const hiddenItems = getHiddenItems(grid);
  const itemsToReveal = hiddenItems.slice(0, count);

  for (const item of itemsToReveal) {
    item.hidden = false;
  }
}

document.addEventListener('click', (event) => {
  const button = event.target instanceof HTMLElement ? event.target.closest(BUTTON_SELECTOR) : null;

  if (!(button instanceof HTMLButtonElement)) return;

  event.preventDefault();

  const grid = getGridFromButton(button);
  if (!(grid instanceof HTMLElement)) return;

  button.disabled = true;

  revealItems(grid, Number.POSITIVE_INFINITY);
  button.hidden = true;
  button.disabled = false;
});

document.addEventListener('DOMContentLoaded', () => {
  for (const button of document.querySelectorAll(BUTTON_SELECTOR)) {
    if (!(button instanceof HTMLButtonElement)) continue;

    const section = button.closest('.shopify-section');
    const grid = section?.querySelector('[ref="grid"]');
    if (!(grid instanceof HTMLElement)) {
      button.hidden = true;
      continue;
    }

    const hiddenCount = getHiddenItems(grid).length;
    button.hidden = hiddenCount <= 0;
    button.disabled = false;
  }
});
